var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 5.41683L10.1667 0.833496L1 5.41683M19.3333 5.41683V14.5835L10.1667 19.1668M19.3333 5.41683L10.1667 10.0002M1 5.41683V14.5835L10.1667 19.1668M1 5.41683L10.1667 10.0002M10.1667 19.1668V10.0002M14.75 3.12516L5.58333 7.7085",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsWhite);
export default __webpack_public_path__ + "static/media/products-white.f428c2ada5c5964d7abb156a50378f93.svg";
export { ForwardRef as ReactComponent };